<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div class="mt-2 col-md-12"></div>


        <b-row v-if="$localStorageService.can('CA_06_menu') && $localStorageService.can('CA_6_iniciar_sesion')">
            <b-col cols="12">
                Debes iniciar sesión en la Agenda para poder utilizar ésta opción
            </b-col>
            <b-col cols="12">
                <b-button variant="primary" @click="redirigir">Ir a Agenda</b-button>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col cols="12">
                No cuentas con permisos para iniciar sesión
            </b-col>
        </b-row>

        <div class="mt-2 col-md-12"></div>
        <div class="mt-2 col-md-12"></div>
        <div class="mt-2 col-md-12"></div>
    </div>
</template>
<script>
    export default {
      data: () => ({
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,
      }),
      created() {
        this.debug = this.$localStorageService.getDebug();
      },
        methods: {
            redirigir() {
                this.$router.push({name: "Schedule"})
            }
        }
    };
</script>
